import axios from "axios";

export function getRoleByUserID(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/users/role/` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function getUserByEmail(qString) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .get(
      `${process.env.REACT_APP_API_URL}v1/users-email` + qString,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function insertEventLog(data) {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}v1/event-logs`, data, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function pingServer() {
  const headerCallAPI = {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("authUserData"))?.token,
      Accept: "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}v1/awake`, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function exchangeToken(data) {
  const headerCallAPI = {
    headers: {
      Accept: "application/json",
    },
  };

  return axios
    .post(
      `${process.env.REACT_APP_API_URL}v1/exchange-token`,
      data,
      headerCallAPI
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export function googleAuth(data) {
  const headerCallAPI = {
    headers: {
      Accept: "application/json",
    },
  };

  return axios
    .post(`${process.env.REACT_APP_API_URL}v1/auth`, data, headerCallAPI)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
